import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';

type Props = { characterId: number; field: 'ac' | 'speed' | 'initiative'; label: string; value: number; onChange: (value: number) => void };

export default function CombatStat({ characterId, field, label, value, onChange }: Props) {
    const { apiRequest } = useAuth();
    const format = (number: number) => field === 'initiative' && number >= 0 ? `+${number}` : String(number);
    const [draft, setDraft] = useState(format(value));
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const save = async () => {
        const next = Number(draft);
        if ((draft.trim() !== '' && !/^[+-]?\d+$/.test(draft.trim())) || !Number.isInteger(next) || next < -2147483648 || next > 2147483647 || (field !== 'initiative' && next < 0)) {
            setError(field === 'initiative' ? 'Enter an integer.' : 'Enter a non-negative integer.');
            return;
        }
        if (next === value) { setDraft(format(next)); setError(''); return; }
        setSaving(true);
        setError('');
        try {
            await apiRequest(`/api/characters/${characterId}/combat`, 'PATCH', { [field]: next });
            onChange(next);
            setDraft(format(next));
        } catch {
            setError('Could not save. Try again.');
        } finally {
            setSaving(false);
        }
    };
    return <>
        <label className="stat-label" htmlFor={`combat-${field}`}>{label}</label>
        <input id={`combat-${field}`} className="stat-value combat-stat-input" type="text" inputMode='numeric' value={draft} disabled={saving} aria-invalid={!!error} aria-describedby={error ? `combat-${field}-error` : undefined}
            onChange={event => setDraft(event.target.value)} onBlur={save}
            onKeyDown={event => { if (event.key === 'Enter') event.currentTarget.blur(); }} />
        {error && <small id={`combat-${field}-error`} role="alert">{error} <button type="button" onClick={save} disabled={saving}>Retry</button></small>}
    </>;
}
